import { arrayOf, shape, string } from "prop-types";
import { useState, useEffect } from "react";

import AnimateHeight from "react-animate-height";
import cx from "classnames";

const propTypes = {
  exploreTitle: shape({
    title: string,
    url: string,
    exploreText: string,
  }),
  folders: arrayOf(shape({})),
  pageId: string,
};

const Menu = (props) => {
  const { exploreTitle, pageId, folders } = props;

  const [activeFolder, setActiveFolder] = useState(null);
  const [activeChild, setActiveChild] = useState(null);

  useEffect(() => {
    //Initialize current folder + child
    let currentFolder, currentChild;
    //Go through folder to find if current pageId value exist
    folders.map((folder, i) => {
      folder.childPages.map((child, j) => {
        if (child.grandChildPages) {
          let pageIdIndex = child.grandChildPages.findIndex(
            (item) => item.pageId === pageId,
          );

          //If value exist,set currentFolder and currentChild
          if (pageIdIndex !== -1) {
            currentFolder = i;
            currentChild = j;
          }
        }
      });
    });

    //If currentFolder and currentChild contain values, update state of activeFolder and activeChild
    if (typeof currentFolder !== undefined && currentChild !== undefined) {
      setActiveFolder(currentFolder);
      setActiveChild(currentChild);
    }
  }, []);

  return (
    <nav className="secondary-navigation__nav">
      {exploreTitle.title && (
        <div className="secondary-navigation__page-title">
          {exploreTitle.url ? (
            <a href={exploreTitle.url}>{exploreTitle.title}</a>
          ) : (
            <span>{exploreTitle.title}</span>
          )}
        </div>
      )}
      <div className="secondary-navigation__folders-wrapper">
        {folders.map((folder, i) => (
          <div key={i}>
            {folder?.title && (
              <div className="secondary-navigation__folder-title">
                {folder.title.href ? (
                  <a href={folder.title.href}>{folder.title.text}:</a>
                ) : (
                  <span>{folder.title.text}:</span>
                )}
              </div>
            )}
            {folder.childPages.map((child, j) =>
              child.grandChildPages ? (
                <div className="secondary-navigation__child" key={child.title}>
                  <div
                    className={cx("secondary-navigation__child-group", {
                      "secondary-navigation__child-btn--open":
                        activeFolder === i && activeChild === j,
                    })}
                    key={child.title}
                    type="button"
                  >
                    {child.href ? (
                      <a href={child.href}>{child.title}</a>
                    ) : (
                      <span>{child.title}</span>
                    )}
                    <button
                      onClick={() => {
                        setActiveFolder(i);
                        setActiveChild((prev) => (prev === j ? null : j));
                      }}
                      className="secondary-navigation__child-dropdown-btn"
                      type="button"
                    >
                      <span className="visually-hidden">toggle menu</span>
                      <div className="secondary-navigation__chevron-child">
                        {activeFolder === i && activeChild === j ? (
                          // Close sign
                          <svg
                            className="accordion__title-control-close"
                            preserveAspectRatio="none"
                            viewBox="0 0 20 20"
                            width="20"
                            height="20"
                            fill="none"
                            stroke="#333333"
                            strokeWidth="2"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <line
                              x1="18"
                              y1="6"
                              x2="6"
                              y2="18"
                              stroke="#333333"
                              strokeWidth="2"
                            />
                            <line
                              x1="6"
                              y1="6"
                              x2="18"
                              y2="18"
                              stroke="#333333"
                              strokeWidth="2"
                            />
                          </svg>
                        ) : (
                          // Plus sign
                          <svg
                            preserveAspectRatio="none"
                            viewBox="0 0 20 20"
                            width="20"
                            height="20"
                            fill="none"
                            stroke="#333333"
                            strokeWidth="2"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <line
                              x1="2"
                              y1="10"
                              x2="18"
                              y2="10"
                              stroke="#333333"
                              strokeWidth="2"
                            />
                            <line
                              x1="10"
                              y1="2"
                              x2="10"
                              y2="18"
                              stroke="#333333"
                              strokeWidth="2"
                            />
                          </svg>
                        )}
                      </div>
                    </button>
                  </div>
                  <AnimateHeight
                    height={
                      activeFolder === i && activeChild === j ? "auto" : 0
                    }
                    aria-hidden={false}
                  >
                    <ul className="secondary-nav__grand-child-list">
                      {child.grandChildPages.map((grandChild, k) =>
                        pageId !== grandChild.pageId ? (
                          <li key={k}>
                            <a href={grandChild.href}>{grandChild.title}</a>
                          </li>
                        ) : (
                          <li key={k} className="current-page">
                            <span>{grandChild.title}</span>
                          </li>
                        ),
                      )}
                    </ul>
                  </AnimateHeight>
                </div>
              ) : (
                <div
                  key={child.title}
                  className="secondary-navigation__child-link"
                >
                  {pageId !== child.pageId ? (
                    <a href={child.href}>{child.title}</a>
                  ) : (
                    <span className="secondary-navigation__child-link--current-page">
                      {child.title}
                    </span>
                  )}
                </div>
              ),
            )}
          </div>
        ))}
      </div>
    </nav>
  );
};

Menu.propTypes = propTypes;
export default Menu;
